/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

import { ApiResponse, ApiResponseError, ErrorData } from '../interfaces'

type AddressResponse = {
  id: number
  version: number
  customer: number
  active: boolean
  dateCreated: string
  initialAddress: boolean
  lastUpdated: string
  cep: string
  name: string
  addressee: string
  street: string
  locationNumber: string
  complement: string
  neighborhood: string
  city: string
  state: string
  type: string
  reference: string
  isComplete: boolean
}

const sendAddressFromMiddleware = async (
  payload: any,
  accessToken: string,
  middleware?: AxiosRequestConfig
): Promise<ApiResponse<AddressResponse | ErrorData>> => {
  try {
    const { data, status } = (await axios({
      ...middleware,
      data: payload,
      headers: { ...middleware?.headers, Authorization: accessToken },
    })) as AxiosResponse<AddressResponse>

    return {
      data,
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ApiResponseError>
    const { data, status } = response!

    return {
      data: data.error,
      status,
      success: false,
    }
  }
}

export default sendAddressFromMiddleware
